export const SET_STEP = 'SET_STEP'
export const SET_VISITED_STEP = 'SET_VISITED_STEP'
export const RESET_VISITED_STEP = 'RESET_VISITED_STEP'
export const SET_RECOMMENDATIONS = 'SET_RECOMMENDATIONS'
export const SET_RECOMMENDATION = 'SET_RECOMMENDATION'
export const RESET_RECOMMENDATION = 'RESET_RECOMMENDATION'
export const SET_CRITERIA_CHANGED = 'SET_CRITERIA_CHANGED'
export const PREP_RECOMMENDATION = 'PREP_RECOMMENDATION'
export const RESET_TRANSLATIONS = 'RESET_TRANSLATIONS'
export const SET_TRANSLATIONS = 'SET_TRANSLATIONS'
export const RESET_RESULTTYPE = 'RESET_RESULTTYPE'
export const SET_RESULTTYPE = 'SET_RESULTTYPE'
export const SET_RESULTTYPES = 'SET_RESULTTYPES'
export const UPDATE_RESULTTYPE = 'UPDATE_RESULTTYPE'
export const SET_ADAS_EXCLUSIONS = 'SET_ADAS_EXCLUSIONS'
export const SET_ADAS_MATRICES = 'SET_ADAS_MATRICES'
export const RESET_ADAS_MATRICES = 'RESET_ADAS_MATRICES'
export const INIT_ADAS_MATRIX = 'INIT_ADAS_MATRIX'
export const UPDATE_ADAS_MATRIX = 'UPDATE_ADAS_MATRIX'
export const UPDATE_ADAS_MATRIXITEM = 'UPDATE_ADAS_MATRIXITEM'
export const SET_ADAS_MATRIX = 'SET_ADAS_MATRIX'
export const SET_DECODED_VIN = 'SET_DECODED_VIN'
export const SET_DECODED_ALT_VIN = 'SET_DECODED_ALT_VIN'
export const INIT_ADAS_MAKE_MATRIX = 'INIT_ADAS_MAKE_MATRIX'
export const SET_ADAS_MAKE_MATRICES = 'SET_ADAS_MAKE_MATRICES'
export const SET_ADAS_MAKE_MATRIX = 'SET_ADAS_MAKE_MATRIX'
export const UPDATE_ADAS_MAKE_MATRIX = 'UPDATE_ADAS_MAKE_MATRIX'
export const SET_ADAS_MAKE_MATRIX_ID = 'SET_ADAS_MAKE_MATRIX_ID'
export const SET_ADAS_MATRIX_INFO_LOOKUPS = 'SET_ADAS_MATRIX_INFO_LOOKUPS'
export const SET_ADAS_MATRIX_INFO_LOOKUP = 'SET_ADAS_MATRIX_INFO_LOOKUP'
export const SET_ADAS_MATRIX_INFO_ID = 'SET_ADAS_MATRIX_INFO_ID'
export const INIT_ADAS_MATRIX_INFO_LOOKUP = 'INIT_ADAS_MATRIX_INFO_LOOKUP'
export const UPDATE_ADAS_MATRIX_INFO_LOOKUP = 'UPDATE_ADAS_MATRIX_INFO_LOOKUP'
export const SET_ADAS_LINKS = 'SET_ADAS_LINKS'
export const SET_ADAS_LINK = 'SET_ADAS_LINK'
export const RESET_ADAS_LINKS = 'RESET_ADAS_LINKS'
export const REMOVE_ADAS_LINKS = 'REMOVE_ADAS_LINKS'
export const RESET_DECODED_ALT_VIN = 'RESET_DECODED_ALT_VIN'
export const SET_MATRIX_CATEGORIES = 'SET_MATRIX_CATEGORIES'
export const SET_MATRIX_SUBCATEGORIES = 'SET_MATRIX_SUBCATEGORIES'
export const SET_MAKE_EXCEPTIONS = 'SET_MAKE_EXCEPTIONS'
export const SET_MATRIX_KEYWORDS_TRIGGERS = 'SET_MATRIX_KEYWORDS_TRIGGERS'
export const SET_MATRIX_ADAS_INFO = 'SET_MATRIX_ADAS_INFO'
export const SET_MAKE_EXCEPTION_LOOKUPS = 'SET_MAKE_EXCEPTION_LOOKUPS'
export const SET_MODEL_VARIABILITY = 'SET_MODEL_VARIABILITY'
export const SESSION_ADAS_MATRIX = 'SESSION_ADAS_MATRIX'
export const SET_NOSCRUB = 'SET_NOSCRUB'
export const SET_NOSCRUBLIST = 'SET_NOSCRUBLIST'
export const UPDATE_NOSCRUB_DATA = 'UPDATE_NOSCRUB_DATA'
export const SET_SYSTEM_CALIBRATIONS = 'SET_SYSTEM_CALIBRATIONS'
export const RESET_CALIBRATIONS = 'RESET_CALIBRATIONS'
export const SET_CALIBRATION_PRICING = 'SET_CALIBRATION_PRICING'
export const RESET_PRICING = 'RESET_PRICING'
export const SET_BLUEPRINT_INFO_LOOKUPS = 'SET_BLUEPRINT_INFO_LOOKUPS'
export const SET_BLUEPRINT_INFO_LOOKUP = 'SET_BLUEPRINT_INFO_LOOKUP'
export const SET_BLUEPRINT_INFO_ID = 'SET_BLUEPRINT_INFO_ID'
export const INIT_BLUEPRINT_INFO_LOOKUP = 'INIT_BLUEPRINT_INFO_LOOKUP'
export const UPDATE_BLUEPRINT_INFO_LOOKUP = 'UPDATE_BLUEPRINT_INFO_LOOKUP'
export const SET_DECODE_SCRUB_RULES = 'SET_DECODE_SCRUB_RULES'
export const SET_DECODE_SCRUB_RULE = 'SET_DECODE_SCRUB_RULE'
export const SET_DECODE_SCRUB_RULE_ID = 'SET_DECODE_SCRUB_RULE_ID'
export const SET_EULAS = 'SET_EULAS'



// WEBPACK FOOTER //
// ./src/store/modules/admin/configuration/types.js